/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Acquisitionstarteddate2Inputs */

const de__field_acquisitionstarteddate2 = /** @type {(inputs: _Field_Acquisitionstarteddate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akquise gestartet`)
};

/**

* @param {_Field_Acquisitionstarteddate2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_acquisitionstarteddate2 = /** @type {((inputs?: _Field_Acquisitionstarteddate2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Acquisitionstarteddate2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_acquisitionstarteddate2(inputs)
});
export { _field_acquisitionstarteddate2 as "_field_acquisitionStartedDate" }